import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2cb3bc8&scoped=true"
import script from "./composition.js?vue&type=script&lang=js&external"
export * from "./composition.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=f2cb3bc8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cb3bc8",
  null
  
)

export default component.exports